import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { ExternalLink } from '@components/Link';
import { ExternalRoutes } from '@constants/routes';
import { LANGUAGE } from '@constants/language';
import { useTranslation } from '@hooks';
import { AppleIcon, BingIcon, ChatGPTIcon, TripAdvisorIcon, YelpIcon } from 'assets/images/integrations';

const Strip = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    flexWrap: 'wrap',
    '& > svg': { width: 22, height: 22, flex: 'none' },
});

const DirectoryLogoStrip = () => {
    const language = useSelector(state => state.auth.user?.language);
    const { t } = useTranslation();

    return (
        <Strip>
            <AppleIcon />
            <BingIcon />
            <TripAdvisorIcon />
            <YelpIcon />
            <ChatGPTIcon />
            <ExternalLink
                href={ExternalRoutes.IntegrationsPage[language] ?? ExternalRoutes.IntegrationsPage[LANGUAGE.ENGLISH]}
                variant="caption"
                underline="hover"
            >
                {t('SettingsCompanies.seeAllDirectories')}
            </ExternalLink>
        </Strip>
    );
};

export default DirectoryLogoStrip;
